export class Work {
  constructor () {
    this.id = null
    this.trainerId = ''
    this.companyName = ''
    this.designation = ''
    this.startDate = ''
    this.endDate = ''
    this.description = ''
    this.keySkills = ''
    this.keySkillsList = []
    this.location = ''
    this.didTraining = false
  }
}



// WEBPACK FOOTER //
// ./src/models/Work.js